import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

// if (document.getElementById('page-top')) {
//   topPage()
// }
// function topPage() {
//  ###    ###  ##   ##
//  ## #  # ##  ##   ##
//  ##  ##  ##  ##   ##
//  ##      ##   ## ##
//  ##      ##    ###

if (document.getElementById('topMv')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars

  const slideItem = document.getElementById('topMv')
  const isRMode = document.body.classList.contains('rMode')

  const wrapperToUse = isRMode
    ? slideItem.querySelector('.swiper-wrapper.mode18')
    : slideItem.querySelector('.swiper-wrapper:not(.mode18)')

  const wrapperToHide = isRMode
    ? slideItem.querySelector('.swiper-wrapper:not(.mode18)')
    : slideItem.querySelector('.swiper-wrapper.mode18')
  if (wrapperToHide) wrapperToHide.remove()

  const sliderName = 'topMv'
  const topMvSwiper = new Swiper(slideItem, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: true, // ループ
    preloadImages: false, // スライド内の画像を読み終えてから開始
    slidesPerView: 1, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
    spaceBetween: 5, //スライド同士の間隔を空ける
    centeredSlides: true, // 中央のスライドを基準にする
    touchRatio: 0.8, // タッチスワイプ感度（0でタッチスワイプ無効）
    fadeEffect: {
      // フェードオプション
      crossFade: true, // クロスフェード
    },
    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたら停止する
      pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
      // stopOnLastSlide: true, // 最終スライドに到達したら停止する
    },
    pagination: {
      // ページャーオプション
      el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
      type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
      clickable: true, // クリックでジャンプ可能にする
    },

    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },
    breakpoints: {
      // 指定px以上でオプション切り替え
      901: {
        spaceBetween: 30, //スライド同士の間隔を空ける
        slidesPerView: 1, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      },
      1400: {
        spaceBetween: 30, //スライド同士の間隔を空ける
        slidesPerView: 2, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      },
    },
  })
}
